import { Component, Input } from '@angular/core';
import { WidgetPosition, WidgetConfig } from './models/GIS-widget.models';
import { VIEW_WIDGETS } from '../../../../../../../../../gis/components/odnr-map/models/widgets.model';

//TODO: REFACTOR TO ALLOW EXCHANGE VIEW_WIDGETS WITH SCENE_WIDGETS WHEN IN SCENE RENDER MODE
@Component({
    selector: 'widget-manager',
    templateUrl: './widget-manager.component.html',
    styleUrls: ['./widget-manager.component.scss'],
    standalone: false
})
export class WidgetManagerComponent {
    @Input()
    config: any;
    availableWidgets = Object.values(VIEW_WIDGETS);
    selectedWidgetType: VIEW_WIDGETS = VIEW_WIDGETS.basemapGallery;

    constructor() { }

    addWidget() {
        if (!this.config.widgets)
            this.config.widgets = [];

        this.config.widgets.push({
            type: this.selectedWidgetType,
            position: WidgetPosition.topLeft
        } as WidgetConfig);
    }

    deleteWidget(widget: WidgetConfig) {
        let idx = this.config.widgets.findIndex(x => x === widget);

        if (idx !== -1)
            this.config.widgets.splice(idx, 1);
    } 

    test(e) {
        console.log(e);
    }
}
